import React from "react";
import { Container, Col } from "react-bootstrap";

const fixed = {
  backgroundImage: `url('https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png')`,
};
function Contact() {
  return (
    <div>
      <div id="resources" className="offset">
        <div className="fixed-background">
          <div className="row dark text-center ">
            <Col sm="12">
              <br />
              <br />
              <br />
              <br />
              <br />
              <h3 className="heading headers">Contact me</h3>

              <br />
              <br />
              <br />
              <br />
              <div className="heading-underline"></div>
            </Col>
          </div>

          <div className="fixed-wrap">
            <div className="fixed" style={fixed}></div>
          </div>
        </div>
      </div>

      <Container>
        <br />
        <br />
        <br />

        <div className="text-center">
          <i className="fa fa-envelope" aria-hidden="true"></i>
          <br />
          <br />

          <p>isajayi@yahoo.com</p>
          <hr />
        </div>
        <br />
        <br />

        <div className="text-center">
          <i className="fa fa-phone" aria-hidden="true"></i>
          <br />
          <br />

          <p>+2348056591917</p>
          <p>+2348067445389</p>
          <hr />
        </div>
        <br />
        <br />

        <div className="text-center">
          <i className="fa fa-home" aria-hidden="true"></i>
          <br />
          <br />

          <p>
            31, Ibikunle Street, Idi-agba titun quarters, Akure, Ondo State,
            Nigeria
          </p>
          <hr />
        </div>

        <br />
        <br />

        <div className="text-center">
          <a
            href="https://www.linkedin.com/in/isaac-ajayi-9a997980?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BjNtLvxKCTAa%2F66XldwrHhg%3D%3D"
            className="email_link3"
          >
            <i
              className="fa fa-linkedin-square linkedln"
              aria-hidden="true"
            ></i>
          </a>

          <br />
          <br />

          <p>
            <a
              href="https://www.linkedin.com/in/isaac-ajayi-9a997980?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BjNtLvxKCTAa%2F66XldwrHhg%3D%3D"
              className="email_link3"
            >
              Connect with me on LinkedIn
            </a>
          </p>
          <hr />
        </div>

        <br />
        <br />
        <div className="text-center">
          <a
            href="mailto:isajayi@yahoo.com?subject = Feedback&body = Message"
            className="email_link3"
          >
            <i className="fa fa-envelope linkedln" aria-hidden="true"></i>
          </a>

          <br />
          <br />

          <a
            href="mailto:isajayi@yahoo.com?subject = Feedback&body = Message"
            className="email_link3"
          >
            <p>Click here to send me an email.</p>
          </a>
          <br />
          <br />
        </div>
      </Container>
    </div>
  );
}

export default Contact;
